import { render, staticRenderFns } from "./canityStatsSection.vue?vue&type=template&id=25a3d513"
import script from "./canityStatsSection.vue?vue&type=script&lang=js"
export * from "./canityStatsSection.vue?vue&type=script&lang=js"
import style0 from "./canityStatsSection.vue?vue&type=style&index=0&id=25a3d513&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports